const diseaseTypeOptions = [
  { value: 'flu', label: 'Flu Accuracy Data' },
  { value: 'covid', label: 'Covid Accuracy Data' },
]

export default diseaseTypeOptions
